/**
 * featureFlags — build-time UI feature gates (b15c C3).
 *
 * Simple compile-time constants used to hide UI surfaces that are not ready
 * for the current launch without deleting their implementation. Flip a flag to
 * re-enable in one line; the gated component code stays intact so there is
 * nothing to rebuild when it ships.
 */

// FEATURE_TEAM_BUILDER: hides the "6 best pokemon team" rectangle on Trade page.
// Set true to re-enable. Hidden for v1.5.x launch — not ready yet.
export const FEATURE_TEAM_BUILDER = false;

